import { render, staticRenderFns } from "./Affinity.vue?vue&type=template&id=40e4bb14"
import script from "./Affinity.vue?vue&type=script&lang=js"
export * from "./Affinity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports